// modal-related export functions
// feel free to change since it is custom code

export function createModalOverlay() {
    const modalOverlay = document.createElement('div');

    modalOverlay.style.position = 'fixed';
    modalOverlay.style.top = '0';
    modalOverlay.style.left = '0';
    modalOverlay.style.width = '100vw';
    modalOverlay.style.height = '100vh';
    modalOverlay.style.display = 'flex';
    modalOverlay.style.alignItems = 'center';
    modalOverlay.style.justifyContent = 'center';
    modalOverlay.style.backgroundColor = '#0007';
    modalOverlay.style.zIndex = '1000'; // Ensure it's on top

    return modalOverlay;
}

export function createModal() {
    const modal = document.createElement('div');

    modal.style.backgroundColor = 'white';
    modal.style.padding = '20px';
    modal.style.borderRadius = '8px';
    modal.style.boxShadow = '0 2px 10px rgba(0, 0, 0, 0.3)';
    modal.style.maxWidth = '400px';
    modal.style.width = '100%';

    return modal;
}

export function createCaption(captionText) {
    const caption = document.createElement('h2');

    caption.innerText = captionText;

    return caption;
}

export function createText(text) {
    const textElem = document.createElement('p');

    textElem.innerText = text;

    return textElem;
}

export function createButtonContainer() {
    const buttonContainer = document.createElement('div');

    buttonContainer.className = 'mt-2 d-flex justify-content-end';

    return buttonContainer;
}

export function createButton({text, invokeFn, cssClass = ''}) {
    const buttonElement = document.createElement('button');

    buttonElement.innerText = text;
    buttonElement.className = cssClass;
    buttonElement.onclick = invokeFn;

    return buttonElement
}

// function to close and clean up the modal
// modalOverlay should contain modal, so we remove modal with overlay
export function closeModal(modalOverlay) {
    document.body.style.backgroundColor = ''; // Reset the background color
    document.body.removeChild(modalOverlay); // Remove modal
}



// WEBPACK FOOTER //
// ./src/scripts/modal.js